<template>
  <div class="index_content">
    <div class="f-row">
      <Breadcrumb separator=">" class="breadcrumb_zdy">
          当前位置:
          <BreadcrumbItem :to="{name: 'NewsList'}">公司</BreadcrumbItem>
          <BreadcrumbItem>公司对比</BreadcrumbItem>
      </Breadcrumb>
      <div>
        <!-- <a href="javascript:history.back(-1)" ><i class="iconfont-sm">&#xe661;</i> 返回上一级页面</a> -->
      </div>
    </div>
    <div class="contain">
        <table class="cus_table">
            <tr>
                <th><p>公司名称</p></th>
                <td v-for="item in com_list" :key="item.uid" width="199px">
                  <div class="comp_info">
                      <div class="logo_img">
                        <img :src="item.logo_path | logo_show" alt="">
                      </div>
                      <div class="comp_name"><p>{{item.short_name}}</p></div>
                  </div>
                </td>
            </tr>
            <tr v-for="(prop,index) in dynview_tag_type" :key="index">
                <th>{{prop.name}}</th>
                <td v-for="item in com_list" :key="item.uid">
                  <div class="tags">
                    <span
                      class="span_tag"
                      v-for="item2 in item.tags"
                      v-if="type_bl(item2, prop.id)"
                      :key="item2">{{item2 | deal('dynview_tag')}}</span>
                  </div>
                </td>
            </tr>
            <tr>
                <th>成立时间</th>
                <td v-for="item in com_list" :key="item.uid">{{item.setup_time | timeTrans}}</td>
            </tr>
            <tr>
                <th>地区</th>
                <td v-for="item in com_list" :key="item.uid">{{item.address_id | addressDeal('2')}}</td>
            </tr>
            <tr>
                <th>规模</th>
                <td v-for="item in com_list" :key="item.uid">{{item.employee_id | deal('employee', 'employee')}}</td>
            </tr>
            <tr>
                <th>融资历程</th>
                <td v-for="item in com_list" :key="item.uid">
                    <ul class="rz_list">
                        <li v-for="item2 in item.event">
                          <p class="p1">
                            <span class="sp1" v-if="item2.type == 1">并购：</span>
                            <span class="sp1" v-else>{{item2.round_id | deal('round', 'name', '未透露')}}：</span>
                            <span class="sp2">{{item2.event_time | timeTrans}}</span>
                            <span class="sp3" v-if="item2.amount">{{item2.amount | amountPrecise(item2.unit_id, item2.precise)}}</span>
                          </p>
                          <p class="p2" v-if="item2.tzf">投资方：<span v-for="(prop,i) in item2.tzf" :key="i"><template v-if="i != 0">、</template>{{prop.entity_name}}</span></p>
                        </li>
                    </ul>
                </td>
            </tr>
        </table>
    </div>
  </div>
</template>

<script>
import { entityCompare } from '@/service'
import { dynview_tag_mixins } from 'js/dynview_tag_mixins'
import filter from 'js/filter'
export default {
  mixins: [dynview_tag_mixins],
  data() {
    return {
      com_list: [],
      params: {
        uids: []
      }
    }
  },
  computed: {
    dynview_tag_type() {
      return this.$store.state.dynview_tag_type
    },
    dynview_tag() {
      return this.$store.state.dynview_tag
    },
    uid_list() {
      let uids = this.$route.query.uids
      return typeof uids == 'string' ? [uids] : uids
    },
    type_bl() {
      return function (data_id, type_id) {
        let index = this.new_tags.findIndex((a) => {return a.id == data_id})
        if (index > -1) {
          if(this.new_tags[index].type_id == type_id){
            return true
          }else {
            return false
          }
        }
      }
    }
  },
  methods: {
    async getComList() {
      this.params.uids = this.uid_list
      let res = await entityCompare(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'com_list', res.res)
      } else {
        this.$Message.error(res.msg)
      }
    }
  },
  created() {
    this.getComList()
    console.log(this.new_tags)
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.index_content
  padding: 16px 0 20px
.contain
  margin-top: 16px
  commonBgColor(#1F2330, #FFFFFF)
  padding: 30px
  position: relative
.cus_table
  // min-width: 100%
  th
    commonColor(#bcbdc1, #666666)
    commonBgColor(#2A2F42, #FFFAF5)
    font-weight: normal
    height: 50px
    width: 176px
    font-size: 14px
    border: 1px solid
    commonBorderColor(#40444F, #F3F3F3)
    p
      min-width: 175px
  td
    padding: 16px
    commonColor(#E9E9EB, #333333)
    border: 1px solid
    commonBorderColor(#40444F, #F3F3F3)
    font-size: 14px
    .tags
      margin-bottom: -10px
      margin-right: -10px
      .span_tag
        padding: 6px 10px
        border-radius: 2px
        margin-right: 10px
        margin-bottom: 10px
        display: inline-block
    .comp_info
      display: flex
      width: 199px
      .logo_img
        flex: 0 0 48px
        height: 48px
        line-height: 46px
      .comp_name
        flex: auto
        margin-left: 8px
        display: table
        height: 48px
        p
          font-size: 14px
          display: table-cell
          vertical-align: middle
    .rz_list
      li
        margin-top: 20px
        &:first-child
          margin-top: 0
        .p1
          .sp1
            color: rgba(250, 122, 80, 1)
          .sp3
            margin-left: 21px
            position: relative
            &:before
              content: ''
              position: absolute
              width: 1px
              height: 14px
              left: -11px
              top: 1px
              commonBgColor(#979797, #D9D9D9)
        .p2
          line-height: 20px
          margin: 7px 0 -3px
</style>
